import { useQuery } from "./urqlHooks";

/** Campos de exchange en indicators — mantener alineado con server Exchange / SupportedCurrency */
const EXCHANGE_FIELDS = `
  EUR
  USD
  UF
  UTM
  MXN
  GBP
  COP
  UYU
  PEN
  JPY
  ARS
  BRL
  CNY
  CAD
`;

const INDICATORS = `query getIndicators {
    getIndicators {
      exchange {
        ${EXCHANGE_FIELDS}
      }
    }
  }`;

export const GetIndicators = () => {
  const [result, reexecuteQuery] = useQuery({
    query: INDICATORS,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_INDICATOR_BY_DATE = `
  query getIndicatorByDate($date: String!) {
    getIndicatorByDate(date: $date) {
      exchange {
        ${EXCHANGE_FIELDS}
      }
      convertionDateToShow
    }
  }
`
export const GetIndicatorByDate = (date) => {
  const shouldPause = !date || date === null || date === undefined || date === '';
  const [result, reexecuteQuery] = useQuery({
    query: GET_INDICATOR_BY_DATE,
    variables: shouldPause ? { date: '' } : { date },
    pause: shouldPause
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}
